import { parseDateISO } from '@practium/shared';
import { z } from 'zod';

const monthValue = z
	.string()
	.regex(/^\d{4}-\d{2}$/, 'Mês inválido');

export const MaintenanceSchema = z.object({
	name: z.string().trim().min(1, 'Identificação é obrigatória'),
	prop: z.string().min(1, 'Propriedade é obrigatória'),
	area: z.string().min(1, 'Área é obrigatória'),
	sectors: z.array(z.string()).min(1, 'Selecione pelo menos um setor'),
	soilAnalysis: z.string().min(1, 'Análise de solo é obrigatória'),
	plantingAdvice: z.string().min(1, 'Informe se deseja usar a adubação de correção'),
	cropStage: z.enum(['growth', 'production', 'prune'], { error: 'Fase da lavoura é obrigatória' }),
	productivity: z.string(),
	parcellingType: z.enum(['fixed', 'dynamic'], { error: 'Tipo de parcelamento é obrigatório' }),
	parcelling: z.string(),
	floweringMonth: z.string(),
	floweringDate: z.string(),
	maturationCycle: z.string(),
}).superRefine((data, ctx) => {
	const addIssue = (path: string, message: string) =>
		ctx.addIssue({ code: 'custom', path: [path], message });

	if (data.parcellingType === 'dynamic') {
		if (!parseDateISO(data.floweringDate)) {
			addIssue('floweringDate', 'Data estimada da florada é obrigatória');
		}
		if (!data.maturationCycle) {
			addIssue('maturationCycle', 'Ciclo de maturação é obrigatório');
		} else if (!data.parcelling) {
			addIssue('maturationCycle', 'Não há parcelamento dinâmico cadastrado para este ciclo');
		}
	} else {
		if (!data.floweringMonth) {
			addIssue('floweringMonth', 'Mês da florada é obrigatório');
		} else if (!monthValue.safeParse(data.floweringMonth).success) {
			addIssue('floweringMonth', 'Mês da florada inválido');
		}
		if (!data.parcelling) addIssue('parcelling', 'Esquema de parcelamento é obrigatório');
	}

	if (data.cropStage === 'growth') return;

	if (!data.productivity) {
		addIssue('productivity', 'Produtividade esperada é obrigatória');
		return;
	}

	const productivity = Number(data.productivity);
	if (!Number.isFinite(productivity)) {
		addIssue('productivity', 'Produtividade deve ser um número válido');
	} else if (productivity <= 0) {
		addIssue('productivity', 'Produtividade deve ser maior que zero');
	}
});

export const MaintenanceIdentificationSchema = z.object({
	name: z.string().trim().min(1, 'Identificação é obrigatória'),
});

export type MaintenanceSchemaType = z.infer<typeof MaintenanceSchema>;
